import { RouteObject } from 'react-router-dom';
import { InsightsPage } from './pages/contact-visualizer';
import Authorizer from './flowVisualiser/components/authorizer';

const routes: RouteObject[] = [
  {
    element: (
      <div className='font-sans font-[450]'>
        <Authorizer />
      </div>
    ),
    children: [
      {
        path: '/portal/insights',
        element: <InsightsPage />
      },
      {
        path: '/portal/insights/contact-visualizer',
        element: <InsightsPage />
      }
    ]
  }
];

export default routes;
